<template>
  <div class="overview-boxes-container">
    <div class="branches_performance">
      <div class="boxes">
        <div class="three">
          <div class="box1 tickets">
            <div class="essentials">
              <p class="number">{{ Tickets }}</p>
              <h4>
                Tickets sold
              </h4>
            </div>
            <!-- <img src="@/assets/increase.svg" /> -->
            <!-- <p class="compare">15 greater than yesterday</p> -->
          </div>
          <div class="box1 funds">
            <div class="essentials">
              <p class="number">{{ totalFunds }}</p>
              <h4>Funds</h4>
            </div>
            <!-- <img src="@/assets/decrease.svg" /> -->
            <!-- <p class="compare">15 less than yesterday</p> -->
          </div>
          <div class="box1 transactionns">
            <div class="essentials">
              <p class="number">{{ transactions }}</p>
              <h4>Transactions</h4>
            </div>
            <!-- <img src="@/assets/increase.svg" /> -->
            <!-- <p class="compare">15 greater than yesterday</p> -->
          </div>
          <div class="box1 journeys">
            <div class="essentials">
              <p class="number">{{ Journeys }}</p>
              <h4>Journeys</h4>
            </div>
            <!-- <img src="@/assets/increase.svg" /> -->
            <!-- <p class="compare">15 greater than yesterday</p> -->
          </div>
          <div class="box1 issues">
            <div class="essentials">
              <p class="number">{{ Issues }}</p>
              <h4>Issues</h4>
            </div>
            <!-- <img src="@/assets/decrease.svg" /> -->
            <!-- <p class="compare">15 less than yesterday</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const overviewApi = "https://bookinga.herokuapp.com/api/v1/shaloiReport/today";
import axios from "axios";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  mounted() {
    axios.get(overviewApi, config).then((res) => {
      this.totalFunds = res.data.data[0].sum;
      (this.transactions = res.data.data[0].transactions),
        (this.Tickets = this.transactions);
      localStorage.setItem("Branchname", res.data.data[0].branchname);
    });
    axios
      .get("https://bookinga.herokuapp.com/api/v1/company/shaloi/getcomp", 
        config
      )
      .then((res) => {
        let companyId = res.data.data[0].id;
        localStorage.setItem("companyId",companyId)
      });
  },
  data() {
    return {
      totalFunds: 0,
      transactions: 0,
      Issues: 0,
      Tickets: 0,
      Journeys: 0,
    };
  },
};
</script>
<style lang="scss" scoped>
.branches_performance {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .performance_today {
    background-color: #f3f6fd;
    border-radius: 5px;
    width: 98%;
    height: 45%;
    // padding: 1% !important;
    margin-left: 1%;
    // margin-bottom: 1%;
  }
}
.boxes {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 97%;
  justify-content: center;
  margin: 0em 0 !important;

  .three {
    margin-bottom: 1.5%;
    display: flex;
    justify-content: space-around;
    height: 55%;
    width: 100%;
    h4 {
      font-size: 0.9em;
      color: $pureWhite;
      font-weight: 400;
    }
    .number {
      font-weight: bold;
      font-size: 1.2em;
      color: $pureWhite;
    }
    .tickets {
      background: linear-gradient(90deg, #a9dbff, #199fff);
    }
    .funds {
      background: linear-gradient(90deg, #2af7df, #449bf8);
    }
    .transactionns {
      background: linear-gradient(90deg, #ffcfa4, #fd7689);
    }
    .journeys {
      background: linear-gradient(90deg, #febe9f, #c0357bb0);
    }
    .issues {
      background: linear-gradient(90deg, #ea98e5, #6f69f6);
    }
    .box1 {
      width: 18%;
      height: 4.5em;
      border-radius: 5px;
      padding: 0.5% 1%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
    }
  }
}
</style>
